// extracted by mini-css-extract-plugin
export default {"blank-page-wrapper":"SbLSPdaR","padded":"qNm7beJ4"};